export class BookNoveltyModel {
  id?: number;
  title: string;
  coverImageBlob: string;
  opacUrl: string;
}
